import React, {useState, useEffect} from 'react';
import {
  View, 
  ActivityIndicator, 
  StyleSheet, 
  Text, 
  Image,
  Dimensions
} from 'react-native';
import { Table, Container } from 'react-bootstrap';
import {getReceiptList} from '../../network/Network';

const HEIGHT = Dimensions.get('window').height
const WIDTH = Dimensions.get('window').width;
const isWeb = WIDTH > 992;

const ReceiptList = (props) => {

  const [receiptData, setReceiptData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    getReceiptList()
      .then((json) => {
        setReceiptData(json.data);
        setIsLoading(false);
      });
  }, []);

  return (
    <Container>
      {
        isLoading
        ?
          <View style={{ height: HEIGHT, backgroundColor: '#202124' }}>
            <ActivityIndicator size="large" />
          </View>
        :
        <View style={{ height: HEIGHT, backgroundColor: '#202124' }}>
        {
          receiptData.length > 0 
          ? (
            <Table responsive striped hover variant="dark">
              <thead>
                <th>Transaction Id</th>
                <th>Transaction On</th>
                <th>MRP</th>
                <th>Tax</th>
                <th>Total Amount</th>
                <th>Transaction For</th>
              </thead>
              <tbody>
                {
                  receiptData.map((item) => {
                    return(
                      <tr>
                        <td>{item.reciept_no}</td>
                        <td>{item.created_at}</td>
                        <td>Rs. {item.mrp}</td>
                        <td>Rs. {item.tax}</td>
                        <td>Rs. {item.total_amount}</td>
                        <td>{item.remark}</td>
                      </tr>
                    );
                  })
                }
              </tbody>
            </Table>
          ) : (
            <Text style={{ color: 'white', fontSize: 24, fontWeight: '500' }}>No receipts are available.</Text>
          )
        }
        </View>
      }
    </Container>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  search: {
    alignSelf: 'flex-end',
    flexDirection: 'row',
    backgroundColor: '#36353ca6',
    alignItems: 'center',
    padding: 10,
    borderRadius: 4,
    marginRight: 20,
    marginBottom: 30,
  },
  input: {
    width: 300,
    color: '#cdcddaf5',
  },
  searchIcon: {
    width: 15,
    height: 15,
    alignSelf: 'flex-end',
  },
  viewStyle: {
    height: HEIGHT,
  },
});

export default ReceiptList;
